import { createFileRoute } from '@tanstack/react-router'
import { MdCheckCircle, MdUnpublished } from 'react-icons/md'
import { useAssistant, useAssistantConfig, useBotConfig, useUpdateAssistantConfig } from '~/api'
import { AppHeading } from '~/components/educator/app/AppHeading'
import { Toggle } from '~/components/shared/Toggle'
import { cn } from '~ui'

export const Route = createFileRoute('/educator/courses/$courseId/apps/$appId/access')({
	component: AppAccess,
})

function AppAccess() {
	const { appId } = Route.useParams()

	const botConfig = useBotConfig()
	const assistant = useAssistant(appId)
	const isEnabled = useAssistantConfig(appId)?.enabled ?? false
	const { mutate: updateAssistantConfig } = useUpdateAssistantConfig()

	const disabled = assistant?.assistantType === 'RAG' && botConfig?.status !== 'Ready'

	return (
		<>
			<AppHeading />
			<h1 className="mb-[4px]">Student access</h1>
			<p className="mb-[24px]">Toggle app visibility in the LMS. When hidden, students won’t have access; when visible, students can use the apps.</p>
			<section
				aria-labelledby="show-learning-assistant-in-lms"
				className="border-dark-grey-25 max-w-text mt-[12px] flex justify-between gap-x-[24px] border p-[24px]"
			>
				<div>
					<h3
						id="show-learning-assistant-in-lms"
						className="text-navy-100 text-[20px] leading-[140%] font-[600]"
					>
						Show learning assistant in LMS
					</h3>
					<p className="mt-[4px]">Toggle on to display and grant students access to the learning assistant within the LMS.</p>
					<div className="flex items-center gap-x-[12px]">
						<div className={cn(isEnabled ? 'bg-light-blue-25' : 'bg-light-grey-25', 'text-navy-100 mt-[12px] flex max-w-max items-center gap-x-[4px] rounded-[2px] px-[8px] py-[4px]')}>
							{isEnabled ? <MdCheckCircle className="size-[16px]" /> : <MdUnpublished className="size-[16px]" />}
							<div>Currently {isEnabled ? 'showing' : 'hidden'}</div>
						</div>
					</div>
				</div>
				<div className="flex items-center justify-center">
					<Toggle
						checked={isEnabled}
						onChange={(checked) => {
							updateAssistantConfig({
								assistantId: appId,
								enabled: checked,
							})
						}}
						disabled={disabled}
						screenReaderLabel="Show learning assistant in LMS"
					/>
				</div>
			</section>
		</>
	)
}
